import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchBalanceSheet } from '../query-api'
import { BalanceSheetReportOptions } from '../types/reportOptions'

export const useFetchBalanceSheetReport = (options: BalanceSheetReportOptions) => {
  const { organization } = useUserOrganization()

  const { data, ...rest } = useQuery(
    [QueryKeys.BalanceSheetLegacy, { organizationId: organization?.id, ...options }],
    () => fetchBalanceSheet({ organizationId: organization?.id as string, options }),
    {
      enabled: !!organization?.id && organization.countryId !== 'NL',
      staleTime: defaultStaleTime,
    },
  )

  return { report: data?.report, ...rest }
}
